import { render, staticRenderFns } from "./SlipDetail.vue?vue&type=template&id=4de54863"
import script from "./SlipDetail.vue?vue&type=script&lang=js"
export * from "./SlipDetail.vue?vue&type=script&lang=js"
import style0 from "./SlipDetail.vue?vue&type=style&index=0&id=4de54863&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports